import { render, staticRenderFns } from "./AboutBoccoChannelView.vue?vue&type=template&id=31028b20&"
import script from "./AboutBoccoChannelView.vue?vue&type=script&lang=ts&"
export * from "./AboutBoccoChannelView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports